import './CooledProductsConflictEntry.css';

import classNames from 'classnames';
import React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { CooledProductsConflictItem } from '../CooledProductsConflictItem';
import { MultipleProducts } from './MultipleProducts';
import { SingleProduct } from './SingleProducts';

interface CooledProductsConflictProps {
    mainProductIncluded: boolean;
    isSelected: boolean;
    onSelect: () => void;
    buttonLabel: string;
    pictureProfile: PictureProfile;
    products: CooledProductsConflictItem[];
    singleLabel?: string;
    multipleLabel?: string;
}

export const CooledProductsConflictEntry = (props: CooledProductsConflictProps) => {
    const { mainProductIncluded, isSelected, onSelect, buttonLabel, pictureProfile, products } = props;

    const isSingleProduct = products.length === 1;

    return (
        <div
            className={classNames('CooledProductsConflictEntry', {
                'CooledProductsConflictEntry--Selected': isSelected,
                'CooledProductsConflictEntry--Single': isSingleProduct,
                'CooledProductsConflictEntry--Multi': !isSingleProduct
            })}
            onClick={onSelect}
        >
            <input
                id={mainProductIncluded ? 'selectThis' : 'selectConflict'}
                className="CooledProductsConflictEntry__Button"
                type="radio"
                checked={isSelected}
                onChange={onSelect}
                onKeyDown={onSelect}
            />
            <label htmlFor={mainProductIncluded ? 'selectThis' : 'selectConflict'} className="visuallyHidden">
                {buttonLabel}
            </label>
            <div className="CooledProductsConflictEntry__Content">
                {isSingleProduct ? (
                    <SingleProduct product={props.products[0]} label={mainProductIncluded ? undefined : props.singleLabel} pictureProfile={pictureProfile} />
                ) : (
                    <MultipleProducts
                        products={props.products}
                        label={mainProductIncluded ? undefined : props.multipleLabel!.replace('{count}', props.products.length.toString())}
                        pictureProfile={pictureProfile}
                    />
                )}
            </div>
        </div>
    );
};
